var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "c-slideoutExternal m-menuSlideout m-menuSlideout--left" },
    [
      _c(
        "div",
        { staticClass: "m-menuSlideout_wrapper" },
        [
          _c("header", { staticClass: "m-menuSlideout_header" }, [
            _c("img", {
              staticClass: "m-menuSlideout_brand",
              attrs: {
                src: require("icon/custom/logo-color-white-horizontal.svg"),
                alt: "logo do CoteiBem",
                title: "Menu do sistema",
              },
            }),
            _vm._v(" "),
            _c("img", {
              staticClass: "m-menuSlideout_close",
              attrs: {
                src: require("icon/custom/modal-close.svg"),
                alt: "fechar",
                title: "fechar",
              },
              on: {
                click: function ($event) {
                  return _vm.$emit("close")
                },
              },
            }),
          ]),
          _vm._v(" "),
          _c("scroll-lock", [
            _c("div", { staticClass: "m-menuSlideout_content" }, [
              _c("div", { staticClass: "m-menuList" }, [
                _c("div", { staticClass: "m-menuList_item" }, [
                  _c(
                    "a",
                    {
                      staticClass: "m-menuList_link",
                      attrs: { title: "Conheça as vantagens de usar CoteiBem" },
                      on: {
                        click: function ($event) {
                          return _vm.showMenu()
                        },
                      },
                    },
                    [
                      _c("span", { staticClass: "m-menuList_text" }, [
                        _vm._v("Pedir orçamentos"),
                      ]),
                    ]
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "m-menuList_item" }, [
                  _c(
                    "a",
                    {
                      staticClass: "m-menuList_link",
                      attrs: {
                        href: _vm.supplierUrl,
                        title: "Veja os depoimentos de quem já usou o CoteiBem",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.$emit("close")
                        },
                      },
                    },
                    [
                      _c("span", { staticClass: "m-menuList_text" }, [
                        _vm._v("Seja um fornecedor"),
                      ]),
                    ]
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "m-menuList_item" }, [
                  _c(
                    "a",
                    {
                      staticClass: "m-menuList_link",
                      attrs: {
                        title: "Acesse sua conta do CoteBem",
                        href: _vm.loginUrl,
                      },
                    },
                    [
                      _c("span", { staticClass: "m-menuList_text" }, [
                        _vm._v("Entrar"),
                      ]),
                    ]
                  ),
                ]),
              ]),
            ]),
          ]),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }